<template>
  <el-dialog
    :title="typeof watchlist.id !== 'undefined' ? 'Edit Watchlist Entry' : 'Add Watchlist Entry'"
    visible
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="watchlistForm"
      v-loading="isSaving"
      :rules="rules"
      :model="watchlist"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Profile"
          >
            <el-select
              v-model="watchlist.profile"
              :loading="isLoadingProfiles"
              value-key="id"
              filterable
              remote
              :remote-method="remoteMethodProfile"
              placeholder="Enter profile name or email"
              class="w-100"
              clearable
            >
              <el-option
                v-for="profile in profiles"
                :key="profile.id"
                :label="formatProfile(profile)"
                :value="profile"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Watch Until"
            prop="watch_until"
          >
            <el-select
              v-model="watchlist.watch_until"
              value-key="id"
              placeholder="Select an option"
              class="w-100"
              filterable
              clearable
            >
              <el-option
                v-for="option in watchUntilOptions"
                :key="option.id"
                :label="option.label"
                :value="option.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Notes"
            prop="notes"
          >
            <el-input
              v-model="watchlist.notes"
              placeholder="Notes"
              type="textarea"
              :rows="4"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="12">
          <el-form-item
            label="Send Notifications"
            prop="send_notifications"
          >
            <el-select
              v-model="watchlist.send_notifications"
              value-key="id"
              placeholder="Send notifications"
              class="w-100"
              default-first-option
            >
              <el-option
                label="No"
                :value="false"
              />
              <el-option
                label="Yes"
                :value="true"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof watchlist.id !== 'undefined' ? updateWatchlist() : createWatchlist()"
      >
        {{ typeof watchlist.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    watchlist: {
      type: Object,
      required: true
    },
    consignmentId: {
      type: String,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      isFullscreen: false,
      profiles: [],
      isLoadingProfiles: false,
      rules: {
        profile: [
          { required: true, message: 'Profile is required', trigger: 'change' }
        ]
      },
      watchUntilOptions: [
        { id: 'is_delivered', label: 'Watch until delivered' },
        { id: 'is_delivered_plus_7', label: 'Watch until 7 days after delivery' },
        { id: 'is_delivered_plus_14', label: 'Watch until 14 days after delivery' },
        { id: 'is_cancelled', label: 'Watch until cancelled' },
        { id: '7_days', label: 'Watch for 7 days' },
        { id: '14_days', label: 'Watch for 14 days' },
        { id: '30_days', label: 'Watch for 30 days' },
        { id: '60_days', label: 'Watch for 60 days' },
        { id: '90_days', label: 'Watch for 90 days' },
        { id: 'indefinitely', label: 'Watch indefinitely' }
      ]
    }
  },
  created () {
    if (this.watchlist.profile) {
      this.profiles = [this.watchlist.profile]
    }
  },
  methods: {
    formatProfile (profile) {
      if (!profile) {
        return '-'
      }

      return profile.name ? `${profile.name} (${profile.email || '-'})` : (profile.email || '-')
    },
    createWatchlist () {
      this.$refs.watchlistForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.watchlist.consignment = { id: this.consignmentId }
          this.watchlist.create()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    updateWatchlist () {
      this.$refs.watchlistForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.watchlist.update()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    remoteMethodProfile (query) {
      this.isLoadingProfiles = true
      this.$sdk.search(query, new this.$sdk.profile())
        .then(res => {
          this.profiles = res
        })
        .finally(() => { this.isLoadingProfiles = false })
    },
    handleSelectProfile (item) {
      this.watchlist.profile = item
    }
  }
}
</script>

<style>

</style>
